var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.45 0.45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.225 0.15a0.075 0.075 0 1 0 0 0.15 0.075 0.075 0 0 0 0 -0.15",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.135 0A0.135 0.135 0 0 0 0 0.135v0.18A0.135 0.135 0 0 0 0.135 0.45h0.18a0.135 0.135 0 0 0 0.135 -0.135v-0.18A0.135 0.135 0 0 0 0.315 0zM0.12 0.225a0.105 0.105 0 1 1 0.21 0 0.105 0.105 0 0 1 -0.21 0M0.33 0.12h0.03V0.09h-0.03z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b378954fb8b9821937e156c8fe091923.svg";
export { ForwardRef as ReactComponent };